import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Thoughts while munching green tea fortune cookies",
  "description": "",
  "published": "2012-12-26T00:00:00.000Z",
  "redirect_from": ["/blog/thoughts-while-munching-green-tea-fortune-cookies/swizec/5776"],
  "categories": "Baking, Food, Green tea, Matcha, Tea, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://farm1.staticflickr.com/3/6930236_ac843de4e1.jpg",
        "alt": "Tea Tin, by Mags",
        "title": "Tea Tin, by Mags"
      }}></img></p>
    <p>{`_`}{`This is a guestpost by `}{`_`}{`Jean Alberti from Wild&Bare Co.`}{`_`}{`_`}</p>
    <p>{`Drinking green tea is good fortune in itself. Eating the tea in a delicious cookie and coming away with a tip about the future is almost too good to be true. As it turns out, it is all possible when green tea fortune cookies are baked and eaten.`}</p>
    <p>{`Baking is not everyone’s specialty and certainly is not especially pertinent to this blog. But green tea is always pertinent and periodically a friend or neighbor will drop around with a plate of green tea fortune cookies, which naturally sparks pleasant thoughts about green tea and the future.`}</p>
    <p>{`The cookies are essentially tuiles, which are thin, pliable pieces of dough that, when hot, are laid across a curving surface and allowed to cool. The resulting shape resembles a piece of tile on a tile roof. Hence, the French name. But they don’t have to be curved; they can be shaped into other shapes—including the bent, folded-over shape of a fortune cookie.`}</p>
    <p>{`They come out green when matcha green tea powder is mixed in the batter with all-purpose flour, sugar, and egg whites. They cool into crisp, tasty treats that break apart easily so the eater can pull out and read the “fortune” printed on the strip of paper tucked into each cookie, and then gobble the cookie itself.`}</p>
    <p>{`So much for the mechanics of green tea fortune cookie-making. How about the atmospherics of eating the cookies: What does the future hold? Some speculation is in order—pass another cookie this way, will you?—as I munch and ponder. How about these futuristic glimpses…`}</p>
    <p><em parentName="p">{`Chef Jean Alberti was raised in a family restaurant near Strasbourg, France. Jean carefully studies the unique soil characteristics and production methods at each tea garden he visits. Guided by local artisans whose families have grown heirloom tea for generations, Jean has curated a line of organic Chinese teas of peerless quality and authenticity.`}</em></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Green tea is here to stay.`}</strong>{` Yes, yes, that doesn’t strike you as a risky call. After all, green tea is a staple drink of millions—probably billions—of people. Why would it suddenly fall into disfavor and be consigned to the history books as a once-popular drink? But that’s the point: I repeat myself… `}<a parentName="li" {...{
          "href": "http://wildandbare.com/our-teas/green-tea/"
        }}>{`green tea`}</a>{` is here to stay. It is healthful, probably more beneficial to human health than we even understand today, wonderful to sip, and pleasurable to serve. Count on it still being served in 3012.`}</li>
      <li parentName="ul"><strong parentName="li">{`Handmade Imperial Tai Ping Hou Kui has more accolades coming its way`}</strong>{`. From the orchid aroma that wafts from the cup to the sweet and fresh taste of the liquid itself, this tea definitely is “imperial” in its presentation and consumption. I predict that anyone lucky enough to get some of this tea from `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Wild_%26_Bare_Co.",
          "title": "Wild & Bare Co."
        }}>{`Wild & Bare Co.`}</a>{` will enjoy a tranquil hour savoring the tea.`}</li>
      <li parentName="ul"><strong parentName="li">{`Handmade Premium Bi Luo Chun has a sweet future`}</strong>{`. This East Mountain tea from `}<a parentName="li" {...{
          "href": "http://maps.google.com/maps?ll=27.6333333333,115.766666667&spn=1.0,1.0&q=27.6333333333,115.766666667%20(Jiangxi)&t=h",
          "title": "Jiangxi"
        }}>{`Jiangxi Province`}</a>{` is a wonderfully fruity brew thanks to the peach, plum, guava, and other fruit tree groves growing in the neighborhood. It is a fresh tasting tea suitable for any time of day. When you tote up its appeal—1) fruity, 2) zesty, 3) enjoyable to sip morning or afternoon—it is no wonder its stock is expected to climb in the years ahead.`}</li>
      <li parentName="ul">{`“`}<strong parentName="li">{`Chinese fortune cookies”—conceived in America using a Japanese cookie recipe—are more tasty than revelatory. `}</strong>{`Case in point: The cookie bakers never gave a clue that a stomach ache would result from eating too many of them. Who could have known!`}</li>
    </ul>
    <p><em parentName="p">{`Chef Jean Alberti was raised in a family restaurant near Strasbourg, France. Jean carefully studies the unique soil characteristics and production methods at each tea garden he visits. Guided by local artisans whose families have grown heirloom tea for generations, Jean has curated a line of organic Chinese teas of peerless quality and authenticity.`}</em></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.thekitchn.com/cookies-made-with-tea-181525"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/131877606_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.thekitchn.com/cookies-made-with-tea-181525"
        }}>{`Cookies Made with Tea: 8 Recipes from Earl Grey to Chai`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.massageenvy.com/blog/time-for-tea"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/116482679_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.massageenvy.com/blog/time-for-tea"
        }}>{`Time for Tea`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://tracysmith.co.uk/green-tea-wonder-drink/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/128375612_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://tracysmith.co.uk/green-tea-wonder-drink/"
        }}>{`Green tea is a wonder-drink`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://revoseek.com/life-style/scientists-green-tea-destroys-liver/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/128659189_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://revoseek.com/life-style/scientists-green-tea-destroys-liver/"
        }}>{`Scientists have Found that Green Tea Destroys the Liver`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=c1a6db08-29d3-4295-b8b6-a8490609cc91",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      